export const assignedTypes = {
    getContacts: 'Obtener Contactos',
    moveContact: 'Mover contacto',
    loadingContacts: 'Cargando Contactos',
    clearIdContact: 'Limpiar Id del contacto que se movio',
    addContact: 'Agregar contacto',
    updateContact: 'Actualizar contacto',
    removeContact: 'Remover contacto',
    markContact: 'Marcar contacto para tomarlo'
}